import React from "react";

const Soccer13XRules = () => {
  return (
    <div>
      <h2>Key Soccer Any 13 Xtra Information</h2>

      <p>
        Soccer Any 13 Xtra combines the best of TAB soccer pools and fixed-odds betting on football into one amazing bet. For soccer fans, it’s the best of two
        worlds in one bet and gives the chance to win big for just a few bucks!
      </p>
      <p>Soccer Any 13 Xtra is like no other TAB soccer bet in that you choose which matches you want to bet on.</p>
      <p>
        For each Soccer Any 13 Xtra pool, TAB gives a list of 30 matches (M1 to M30) and customers must select which 13 games they want to include in their bet.
      </p>
      <p>As with all TAB soccer bets, one team is shown as Team A (normally the home team if applicable) and the other as Team B.</p>
      <p>There are three result options:</p>

      <ol>
        <li>Team A Win</li>
        <li>Draw</li>
        <li>Team B Win</li>
      </ol>
      <p>
        You can play a single or multiple entry. With a single entry, you select ONE option or choice for each of the 13 matches chosen and the bet costs R2.
      </p>
      <p>
        With a multiple entry, you can choose more than one option in one or more matches. The cost is R2 per combination. To calculate the number of
        combinations and therefore the cost, multiply out the total number of options or choices for each match.
      </p>

      <p>
        <strong>Example ONE: </strong>You choose all three result options in one match, two options in four games and one in each of the other eight matches
        chosen. That's 3x2x2x2x2x1x1x1x1x1x1x1x1 = 48 combinations @ R2 per combination = R96.
      </p>

      <p>
        <strong>Example TWO: </strong>You choose two options in four matches and one in each of the other nine games. That's 2x2x2x2x1x1x1x1x1x1x1x1x1 = 16
        combinations @ R2 per combination = R32.
      </p>

      <p>
        70% of the pool is allocated for bets with all 13 matches correct and the other 30% of pool for entries with any 12 of 13 matches correct. If the 70%
        portion of the pool is not won, it is carried forward to the 70% portion of a selected TAB soccer pool.
      </p>
      <p>If nobody forecasts any 12 matches correctly, the 30% portion of the pool is paid to any 11 games correct (or any 10 etc).</p>

      <p>
        <strong>NOTE: </strong>You must enter a result option/s for 13 matches – not more and not less or the bet will be invalid.
      </p>

      <p>
        TAB customers playing the bet in a TAB branch must use the special TAB Soccer YOU CHOOSE THE MATCHES betting form. Mark the V3 oval at the top, the S13X
        oval and a choice/s in 13 matches.
      </p>
    </div>
  );
};

export default Soccer13XRules;
